const snackbarMessageConstants = {
  shipment_eligibility_change: `In order to save this location as shipment eligible, 
                                a user must be specified as the primary contact. 
                                If this is not possible, shipment eligibility
                                must be set to 'no' (this can be updated later).`,
};

export { snackbarMessageConstants };
